const proxyConfig = require('./proxyConfig');
const
    testOptions  = {
         PAGE_ROWS:                     100
        ,FILTERS_LIMIT:                 10
        ,SQS_ENABLED:                   'N' // Y o N
        ,CONTAINER_ENABLED:             'N' // Y o N
        ,COGNITO_ENABLED:               'N' // Y o N
        ,COGNITO_DOMAIN:                ''
        ,COGNITO_EXPIRE_EXTRA_SEC:      0 // (1800) secondi per il rinnovo di access token prima della sua scadenza
        ,REACT_APP_AWS_POOL_ID:         ''
        ,REACT_APP_AWS_APP_CLIENT_ID:   ''
        ,EXTERNAL_IDP_ENABLED:          'N' // Y o N
        ,HUB:                           ''
        ,TOKEN_NAMES:                   false // { 'tipoditoken': 'nomedeltoken' }
        ,DECODE_CLIENT_COD:             { 1: 'Cairo', 7: 'Discovery', 9: 'Conde Nast', 10: 'Il Sole 24 Ore', 12: 'IGP' }
        ,DEBUG:                         { App: true, AuthService: true ,FetchService: true ,Login: true }
    }

    ,prodOptions = {
         PAGE_ROWS:                     100
        ,FILTERS_LIMIT:                 100
        ,DEBUG:                         {}
    }

    ,environment = {
         local:         { ...testOptions  ,API_URL: 'https://backend.systrategy.it/roobeek-dev' } // 'http://localhost:65019' } // 'https://backend.systrategy.it/roobeek-dev' }
        ,dev:           { ...testOptions  ,API_URL: 'https://backend.systrategy.it/roobeek-dev' }
        ,demo:          { ...prodOptions  ,API_URL: 'https://backend.demo.systrategy.com/roobeek'               /* DA AGGIORNARE */
                                          ,CONTAINER_ENABLED: 'Y' }


        ,localdisco:    { ...testOptions  ,CONTAINER_ENABLED: 'Y' 
                                          ,...(proxyConfig[ process.env.REACT_APP_ENV ] || {}) }
        ,localproddisco:{ ...testOptions  ,CONTAINER_ENABLED: 'Y' 
                                          ,...(proxyConfig[ process.env.REACT_APP_ENV ] || {}) }
        ,devdisco:      {                  API_URL: 'https://backend.dev.wbdiscovery.systrategy.com/roobeek'
                                          ,PAGE_ROWS:         300
                                          ,FILTERS_LIMIT:     300
                                          ,CONTAINER_ENABLED: 'Y'  }
        ,proddisco:     {                  API_URL: 'https://backend.wbdiscovery.systrategy.com/roobeek'
                                          ,PAGE_ROWS:         300
                                          ,FILTERS_LIMIT:     300
                                          ,CONTAINER_ENABLED: 'Y'  }


        ,devcairo:      { ...prodOptions  ,API_URL: 'https://backend.dev.cairorcsmedia.systrategy.com/roobeek'  /* DA AGGIORNARE */
                                          ,CONTAINER_ENABLED: 'Y' }
        ,prodcairo:     { ...prodOptions  ,API_URL: 'https://backend.cairorcsmedia.systrategy.com/roobeek'      /* DA AGGIORNARE */
                                          ,CONTAINER_ENABLED: 'Y' }
                                          

        ,devsole:       { ...prodOptions  ,API_URL: 'https://backend.dev.ilsole24ore.systrategy.com/roobeek'
                                          ,CONTAINER_ENABLED: 'Y' }
        ,prodsole:      { ...prodOptions  ,API_URL: 'https://backend.ilsole24ore.systrategy.com/roobeek'
                                          ,CONTAINER_ENABLED: 'Y' }


        ,localigp:      { ...testOptions  ,CONTAINER_ENABLED: 'Y' 
                                          ,...(proxyConfig[ process.env.REACT_APP_ENV ] || {}) }
        ,devigp:        { ...prodOptions  ,API_URL: 'https://backend.dev.igp.systrategy.com/roobeek'            /* DA AGGIORNARE */
                                          ,CONTAINER_ENABLED: 'Y' }
        ,prodigp:       { ...prodOptions  ,API_URL: 'https://backend.igp.systrategy.com/roobeek'                /* DA AGGIORNARE */
                                          ,CONTAINER_ENABLED: 'Y' }
        

        ,devconde:      { ...prodOptions  ,API_URL: 'https://backend.dev.condenast.systrategy.com/roobeek'      /* DA AGGIORNARE */
            ,CONTAINER_ENABLED:             'Y'
            ,COGNITO_ENABLED:               'Y'
            ,COGNITO_DOMAIN:                'https://dev.auth.condenast.systrategy.com'
            ,COGNITO_EXPIRE_EXTRA_SEC:      120
            ,REACT_APP_AWS_POOL_ID:         'eu-west-3_wB2OK1Dkl'
            ,REACT_APP_AWS_APP_CLIENT_ID:   '4ugotf9115e3h7oet9hj5v6fon'
            ,EXTERNAL_IDP_ENABLED:          'Y'
            ,HUB:                           'dev.condenast.systrategy.com'
            ,COOKIE_DOMAIN:                 'condenast.systrategy.com'
            ,COGNITO_LOGOUT_REVOKE_REFRESH: 'N'
            ,COGNITO_LOGOUT_ENABLED:        'N'
            ,COGNITO_RENEW_ACCESS_ENABLED:  'N'
            ,TOKEN_NAMES:                   {
                 RefreshToken:  'hubRefreshTokenDev'  // Cognito Token di aggiornamento (chiave di rinnovo)
                ,AccessToken:   'hubAccessTokenDev'   // Cognito Token di accesso (informazioni sui permessi dell'utente)
                ,IdToken:       'hubIdTokenDev'       // Cognito Token ID (informazioni sull'identità dell'utente)
            }
        }
        ,prodconde:     { ...prodOptions  ,API_URL: 'https://backend.condenast.systrategy.com/roobeek'
            ,CONTAINER_ENABLED:             'Y'
            ,COGNITO_ENABLED:               'Y'
            ,COGNITO_DOMAIN:                'https://prod.auth.condenast.systrategy.com'
            ,COGNITO_EXPIRE_EXTRA_SEC:      1800
            ,REACT_APP_AWS_POOL_ID:         'eu-west-3_9bgvLYP7I'
            ,REACT_APP_AWS_APP_CLIENT_ID:   '2sqjsa71208vsuqs9s1kur54sl'
            ,EXTERNAL_IDP_ENABLED:          'Y'
            ,HUB:                           'condenast.systrategy.com'
            ,COOKIE_DOMAIN:                 'condenast.systrategy.com'
            ,COGNITO_LOGOUT_REVOKE_REFRESH: 'N'
            ,COGNITO_LOGOUT_ENABLED:        'N'
            ,COGNITO_RENEW_ACCESS_ENABLED:  'N'
            ,TOKEN_NAMES:                   {
                 RefreshToken:  'hubRefreshTokenProd'  // Cognito Token di aggiornamento (chiave di rinnovo)
                ,AccessToken:   'hubAccessTokenProd'   // Cognito Token di accesso (informazioni sui permessi dell'utente)
                ,IdToken:       'hubIdTokenProd'       // Cognito Token ID (informazioni sull'identità dell'utente)
            }
        }

    }
    ,config      = () => ({
        ...( environment[ process.env.REACT_APP_ENV ] || {} )
        ,ENVIRONMENTS: environment // Questo è sbagliato, si porta dietro la configurazione di tutti i clienti. Sarebbe necessarion estrarlo come segue: { [process.env.REACT_APP_ENV]: { ...( environment[ process.env.REACT_APP_ENV ] || {} )} }
    })
;

export default config();
